import { useRouter } from "expo-router";
import { useCallback, useEffect } from "react";
import { ScrollView, StyleSheet } from "react-native";
import { AppStorage } from "../../src/services/AppStorage";

import { isNative } from "@stepapp/core";
import { Block, Button, SvgIcon, Typography, palette, spacing } from "@stepapp/ui";
import { useTranslation } from "react-i18next";

const AppUpdateScreen = () => {
  const { t } = useTranslation();
  const { replace } = useRouter();
  const isAuthenticated = !!AppStorage().get("token");
  const afterWalkthrough = AppStorage().get("afterWalkthrough");
  const profileInitialised = isAuthenticated || afterWalkthrough;

  useEffect(() => {
    AppStorage().set("sawChangelog", true);
  }, []);

  const goToApp = useCallback(() => {
    if (isNative && !profileInitialised) {
      return replace("/welcome/");
    }
    replace("/");
  }, [replace, profileInitialised]);

  return (
    <ScrollView style={styles.container}>
      <SvgIcon name="cake" size={24} style={styles.cakeIcon} />

      <Block alignCenter paddingVertical={3.5}>
        <Typography center type="white" variant="newH1">
          {t("screens.appUpdate.title")}
        </Typography>

        <Block marginTop={4}>
          <Typography center type="white" variant="body">
            {t("screens.appUpdate.description")}
          </Typography>
        </Block>
      </Block>

      {[...new Array(5).keys()].map((index) => (
        <Block row key={`feature-${index + 1}`} paddingBottom={0.5}>
          <Block style={styles.dot} />
          <Typography type="white" variant="paragraph">
            {t(`screens.appUpdate.feature${(index + 1) as 1 | 2 | 3 | 4 | 5}`)}
          </Typography>
        </Block>
      ))}

      <Button
        label={t("common.continue")}
        onPress={goToApp}
        style={styles.confirmButton}
        type="quaternary"
      />
    </ScrollView>
  );
};

export default AppUpdateScreen;

const styles = StyleSheet.create({
  cakeIcon: {
    alignSelf: "center",
  },
  confirmButton: {
    justifyContent: "flex-end",
    marginTop: spacing.unit * 4,
    paddingBottom: spacing.unit * 5,
  },
  container: {
    backgroundColor: palette.primary.accent,
    paddingHorizontal: spacing.unit * 4,
    paddingTop: spacing.unit * 15,
  },
  dot: {
    backgroundColor: palette.common.white,
    borderRadius: spacing.unit * 1,
    height: spacing.unit * 0.375,
    marginBottom: spacing.unit * 0.5,
    margin: spacing.unit * 1,
    width: spacing.unit * 0.375,
  },
});
